@if (isLoading) {
  <app-loader [loading]="isLoading" [size]="64"></app-loader>
} @else {
  <div [ngClass]="{'with-footer-alternative-x2': utilService.isMobile}" *ngIf="!isInternalComponent">
    <a class="link bottom-spacer" *ngIf="!isRegister" (click)="back()">
      <mat-icon class="svg-icon" [svgIcon]="'arrow_left'"></mat-icon>
      <span>{{ 'general.api_legal_persons_back_to_list' | translate }}</span>
    </a>
    <!-- HEADING -->
    <div class="flex space-between">
      <div class="heading-1">
        <ng-container *ngTemplateOutlet="headersTemplate"></ng-container>
      </div>
      <div class="desktop flex">
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
      </div>
    </div>
    <mat-card appearance="outlined" *ngIf="!utilService.isMobile || isRegister">
      <ng-container *ngTemplateOutlet="generalFormTemplate"></ng-container>
    </mat-card>
    <mat-tab-group class="top-spacer-negative" mat-align-tabs="left" animationDuration="0ms" [(selectedIndex)]="viewTab" (selectedTabChange)="updateByTab($event)" *ngIf="!isRegister">
      <mat-tab [label]="'general.api_legal_persons_tab_general_info' | translate" *ngIf="utilService.isMobile">
        <mat-card appearance="outlined">
          <ng-container *ngTemplateOutlet="generalFormTemplate"></ng-container>
        </mat-card>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_connected_persons' | translate" *ngIf="isAnyConnectedPersons">
        <ng-container *ngTemplateOutlet="projectManagerTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="contactPersonsTemplate"></ng-container>
        <ng-container *ngTemplateOutlet="representativesTemplate"></ng-container>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_billing' | translate" *ngIf="canChange && authService.checkPrivileges(Privileges.LEGAL_PERSON_BANK_ACCOUNT_VIEW)">
        <ng-container *ngTemplateOutlet="billingTemplate"></ng-container>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_admin_info' | translate" *ngIf="canChangeAll">
        <ng-container *ngTemplateOutlet="adminInfoTemplate"></ng-container>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_audit_log' | translate" *ngIf="canSeeAuditLogs" [aria-label]="AUDIT_LOG_TAB_ARIA_LABEL">
        <ng-container *ngTemplateOutlet="auditLogTemplate"></ng-container>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_commission_fees' | translate" *ngIf="viewService.conf.environment?.length && canSeeCommissionFees">
        <app-commission-fees *ngIf="legalPerson?.id" [commissionLevel]="CommissionLevel.Legal"
                             [baseId]="legalPerson.id" [baseName]="legalPerson.companyName"></app-commission-fees>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_analytics_trackers' | translate" *ngIf="viewService.conf.environment?.length && canManageAnalyticsTrackers">
        <ng-container *ngTemplateOutlet="analyticsTrackersTemplate"></ng-container>
      </mat-tab>
      <mat-tab [label]="'general.api_legal_persons_tab_owner_centre_settings' | translate" *ngIf="canSetOwnerCentreSettings">
        <ng-container [ngTemplateOutlet]="ownerCentreSettingsTemplate"></ng-container>
      </mat-tab>
    </mat-tab-group>
    <footer class="mobile" *ngIf="canChange">
      <div class="mat-mdc-dialog-actions">
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
      </div>
    </footer>
  </div>
  <ng-container *ngIf="isInternalComponent">
    <!-- HEADING -->
    <app-section-header [titleTemplate]="headersTemplate"></app-section-header>
    <ng-container *ngTemplateOutlet="generalFormTemplate"></ng-container>
    <div class="flex flex-end top-spacer" [ngClass]="{'desktop': !withoutFooter}">
      <ng-container *ngTemplateOutlet="internalComponentButtons"></ng-container>
    </div>
    <footer class="mobile" *ngIf="!withoutFooter">
      <mat-dialog-actions>
        <ng-container *ngTemplateOutlet="internalComponentButtons"></ng-container>
      </mat-dialog-actions>
    </footer>
  </ng-container>
}

<ng-template #buttons>
  <button mat-button *ngIf="isRegister" (click)="continueWithoutLegal()">{{ 'general.api_legal_persons_form_continue_without' | translate }}</button>
  <button mat-flat-button color="primary" *ngIf="isRegister" [disabled]="!isValid" (click)="isValid && register()">{{ 'general.api_legal_persons_form_register' | translate }}</button>
  <button mat-flat-button color="primary" *ngIf="isCreate" [disabled]="!isValid" (click)="isValid && create()">{{ 'general.api_legal_persons_form_create' | translate }}</button>
  <button mat-flat-button color="primary" *ngIf="canChange && isView" [disabled]="!isValid" (click)="isValid && update()">{{ 'general.api_legal_persons_form_save' | translate }}</button>
  <button mat-flat-button color="primary" *ngIf="!isBusinessAccount && !!this.legalPerson.id" [disabled]=" isModelChanged" (click)="confirmClaimLegal()">{{ 'general.api_legal_persons_claim_legal' | translate }}</button>
</ng-template>

<ng-template #internalComponentButtons>
  <button mat-button (click)="cancel()">{{ (isReadonly ? 'general.api_general_close' : 'general.api_legal_persons_form_cancel') | translate }}</button>
  <button mat-flat-button color="primary" *ngIf="!isReadonly && (!legalPersonId || (legalPersonId && canChange))"
          [disabled]="!isValid" (click)="isValid && (legalPersonId ? update() : create())">
    {{ (legalPersonId ? 'general.api_legal_persons_form_save' : 'general.api_legal_persons_form_create') | translate }}
  </button>
</ng-template>

<ng-template #headersTemplate>
  <ng-container *ngIf="isCreate">{{ 'general.api_legal_persons_form_create_title' | translate }}</ng-container>
  <ng-container *ngIf="isView">{{ 'general.api_legal_persons_form_view_title' | translate }}</ng-container>
  <ng-container *ngIf="isRegister">{{ 'general.api_legal_persons_form_register_title' | translate }}</ng-container>
</ng-template>

<ng-template #generalFormTemplate>
  <app-section-header [title]="'general.api_legal_persons_general_info'" [useInternalDesign]="isInternalComponent"></app-section-header>
  <div class="flex align-left flex-autosize flex-column-mobile" *ngIf="!isInternalComponent">
    <ng-container *ngTemplateOutlet="mainPart1"></ng-container>
    <ng-container *ngTemplateOutlet="mainPart2"></ng-container>
  </div>
  <ng-container *ngIf="isInternalComponent">
    <div class="flex align-left flex-autosize flex-column-mobile top-spacer">
      <ng-container *ngTemplateOutlet="mainPart1"></ng-container>
    </div>
    <div class="flex align-left flex-autosize flex-column-mobile top-spacer">
      <ng-container *ngTemplateOutlet="mainPart2"></ng-container>
    </div>
  </ng-container>
  <div class="flex flex-grow flex-column-mobile" *ngIf="!isInternalComponent">
    <div class="flex flex-column max-width">
      <div class="flex flex-wrap">
        <mat-slide-toggle [(ngModel)]="isLiableForVat" (change)="checkVatCodeForChanges()" [ngModelOptions]="{standalone: true}"
                          [disabled]="isExemptFromVat || (isView && !canChange)">
          <span>{{ 'general.api_legal_persons_form_vat_liable' | translate }}</span>
        </mat-slide-toggle>
        <mat-slide-toggle [(ngModel)]="isExemptFromVat" (change)="checkExemptCodeForChanges()" [ngModelOptions]="{standalone: true}"
                          [disabled]="isLiableForVat || (isView && !canChange)">
          <span>{{ 'general.api_legal_persons_form_vat_exemption' | translate }}</span>
        </mat-slide-toggle>
      </div>
      <div class="flex flex-wrap" *ngIf="isLiableForVat">
        <app-text-input [appClass]="'responsive-input'" [label]="'general.api_legal_persons_form_vat_code'"
                        [(value)]="legalPerson.vatCode" (valueChange)="pendingChanges = true"
                        [required]="true" [disabled]="isView && !canChange"></app-text-input>
        <app-numeric-input [type]="NumericInputType.Percentage" [label]="'general.api_legal_persons_form_vat_percent'"
                           [(value)]="legalPerson.vatPercent" [allowPercentageDecimalPlaces]="true" (valueChange)="pendingChanges = true"
                           [disabled]="isView && !canChange" [required]="true"></app-numeric-input>
      </div>
      <div class="flex flex-wrap" *ngIf="isExemptFromVat">
        <app-text-input [appClass]="'responsive-input'" [label]="'general.api_legal_persons_form_vat_exemption_code'"
                        [(value)]="legalPerson.vatExemptionCode" (valueChange)="pendingChanges = true"
                        [customErrorFunction]="isVatExemptCodeInvalid" [customError]="'general.api_legal_person_vat_exemption_code_invalid'"
                        [required]="true" [disabled]="isView && !canChange"></app-text-input>
      </div>
      <!--<mat-checkbox class="top-spacer" [(ngModel)]="agreedWithDocument" [disabled]="isView" [ngModelOptions]="{standalone: true}">
        <div [innerHTML]="'general.api_legal_persons_form_agreement_document' | translate"></div>
      </mat-checkbox>-->
      <app-label-value *ngIf="!isInternalComponent && !isRegister" class="top-spacer"
                       [withMargin]="true"
                       [label]="'general.api_legal_persons_form_account_type'"
                       [value]="isBusinessAccount ? 'general.api_legal_persons_form_business_account' : 'general.api_legal_persons_form_customer_account'"></app-label-value>
    </div>
  </div>
  <hr class="slim">
  <app-section-header [title]="'general.api_legal_persons_form_company_address'" [useInternalDesign]="isInternalComponent"></app-section-header>
  <ng-container *ngTemplateOutlet="addressTemplate; context: {address: legalPerson.address}"></ng-container>
  <ng-container *ngIf="!isInternalComponent">
    <mat-checkbox class="top-spacer" [(ngModel)]="contactAddressIsDifferent" (change)="pendingChanges = true" [disabled]="isView && !canChange" [ngModelOptions]="{standalone: true}">
      {{ 'general.api_legal_persons_form_contact_address_is_different' | translate }}
    </mat-checkbox>
    <ng-container *ngIf="contactAddressIsDifferent">
      <hr class="slim">
      <app-section-header [title]="'general.api_legal_persons_form_contact_address'" [useInternalDesign]="isInternalComponent"></app-section-header>
      <ng-container *ngTemplateOutlet="addressTemplate; context: {address: legalPerson.contactAddress}"></ng-container>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #mainPart1>
  <app-text-input [appClass]="'responsive-input'" [label]="'general.api_legal_persons_form_company_name'"
                  [(value)]="legalPerson.companyName" (valueChange)="pendingChanges = true"
                  [required]="true" [disabled]="isView && !canChangeAll"></app-text-input>
  <app-text-input [appClass]="'responsive-input'" [label]="'general.api_legal_persons_form_reg_number'"
                  [(value)]="legalPerson.regNumber" (valueChange)="pendingChanges = true"
                  [hasCustomError]="isRegNumberExist" [customError]="'general.api_legal_persons_form_reg_number_already_exist'"
                  [max]="COMPANY_REG_NO_MAX_LENGTH" [required]="true" [disabled]="isView && !canChangeAll">
  </app-text-input>
</ng-template>
<ng-template #mainPart2>
  <app-text-input [type]="TextInputType.Email" [appClass]="'responsive-input'" [label]="'general.api_legal_persons_form_email'"
                  [(value)]="legalPerson.email" (valueChange)="pendingChanges = true"
                  [required]="true" [disabled]="isView && !canChange"></app-text-input>
  <app-phone-input [ngClass]="{'responsive-input': !utilService.isMobile}"
                   [(phoneNr)]="legalPerson.phone"
                   (phoneNrChange)="legalPersonOrig.phone !== legalPerson.phone ? pendingChanges = true : null"
                   [disabled]="isView && !canChange"
                   [label]="'general.api_legal_persons_form_phone'"
                   (isValid)="isPhoneNrValid = $event">
  </app-phone-input>
</ng-template>

<ng-template #addressTemplate let-address="address">
  <div class="flex flex-grow flex-column-mobile" *ngIf="!isInternalComponent">
    <ng-container *ngTemplateOutlet="addressPart1; context: { address }"></ng-container>
    <ng-container *ngTemplateOutlet="addressPart2; context: { address }"></ng-container>
    <ng-container *ngTemplateOutlet="addressPart3; context: { address }"></ng-container>
  </div>
  <ng-container *ngIf="isInternalComponent">
    <div class="flex flex-autosize flex-column-mobile align-left top-spacer">
      <ng-container *ngTemplateOutlet="addressPart1; context: { address }"></ng-container>
    </div>
    <div class="flex flex-autosize flex-column-mobile align-left top-spacer">
      <ng-container *ngTemplateOutlet="addressPart2; context: { address }"></ng-container>
    </div>
    <div class="flex flex-autosize flex-column-mobile align-left top-spacer">
      <ng-container *ngTemplateOutlet="addressPart3; context: { address }"></ng-container>
      <div></div>
    </div>
  </ng-container>
</ng-template>

<ng-template #addressPart1 let-address="address">
  <mat-form-field appearance="outline" class="no-hint">
    <mat-label>{{ 'general.api_legal_persons_form_address_country' | translate }}</mat-label>
    <mat-select [(ngModel)]="address.countryCode" (selectionChange)="pendingChanges = true" [disabled]="isView && !canChange" [required]="true">
      <mat-option>
        <app-select-search [values]="countryService.translatedCountries" [filterBy]="['translationKey']" [translateValues]="true" (filteredValues)="countriesFiltered.next($event.slice())"></app-select-search>
      </mat-option>
      <mat-select-trigger>{{ countryService.getCountryTranslationKey(address.countryCode) | translate }}</mat-select-trigger>
      <mat-option *ngFor="let country of countriesFiltered | async" [value]="country.code">
        {{ country.translationKey | translate }}
      </mat-option>
      <mat-option *ngFor="let country of countryService.translatedCountries" [value]="country.code" class="hide" disabled>
        {{ country.translationKey | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <app-text-input [label]="'general.api_legal_persons_form_address_county'"
                  [(value)]="address.county" (valueChange)="pendingChanges = true"
                  [required]="true" [disabled]="isView && !canChange"></app-text-input>
</ng-template>
<ng-template #addressPart2 let-address="address">
  <app-text-input [label]="'general.api_legal_persons_form_address_city'"
                  [(value)]="address.city" (valueChange)="pendingChanges = true"
                  [required]="true" [disabled]="isView && !canChange"></app-text-input>
  <app-text-input [label]="'general.api_legal_persons_form_address_street'"
                  [(value)]="address.street" (valueChange)="pendingChanges = true"
                  [required]="true" [disabled]="isView && !canChange"></app-text-input>
</ng-template>
<ng-template #addressPart3 let-address="address">
  <app-text-input [label]="'general.api_legal_persons_form_address_postalCode'"
                  [(value)]="address.postalCode" (valueChange)="pendingChanges = true"
                  [required]="true" [disabled]="isView && !canChange"></app-text-input>
</ng-template>

<ng-template #promotersTemplate>
  <mat-card appearance="outlined" *ngIf="(!legalPerson.salespoints.length || legalPerson.salespoints[0].supportsYbo) && (canChange || legalPerson.promoters.length)">
    <div class="flex flex-wrap space-between">
      <app-section-header [title]="'general.api_legal_persons_form_promoters'" [tooltip]="'general.api_legal_persons_form_promoters_tooltip'"></app-section-header>
      <div *ngIf="canChange">
        <a class="link" (click)="addPromoter()">
          <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
          <span>{{ 'general.api_legal_persons_form_add_promoter' | translate }}</span>
        </a>
      </div>
    </div>
    <ng-container *ngIf="legalPerson.promoters?.length">
      <table class="report-table top-spacer">
        <thead>
          <tr>
            <th class="max-width">
              <div class="subtitle">
                {{ 'general.api_legal_persons_form_reg_number' | translate }} ({{ 'general.api_legal_persons_form_directo_code' | translate }})
              </div>
            </th>
            <th class="min-width" *ngIf="canChange">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let promoterId of legalPersonPromoterIds; let promoterIndex = index">
            <td>
              <span *ngIf="!editPromoters[promoterId] || !canChange || authService.user.isSubCentre">
                    <ng-container *ngIf="{promoterObject: getPromoter(promoterId)} as current">
                      <span class="title">{{ current.promoterObject?.title || '-' }}</span>
                      <ng-container *ngIf="current.promoterObject?.regNumber || current.promoterObject?.ocraCode"><br></ng-container>
                      {{current.promoterObject?.regNumber}}
                      <span *ngIf="current.promoterObject?.ocraCode">({{ current.promoterObject.ocraCode }})</span>
                    </ng-container>
              </span>
              <app-scroll-load *ngIf="editPromoters[promoterId] && canChange && !authService.user.isSubCentre && promoterScrollLoadList[promoterIndex]"
                               [maxWidth]="true"
                               [label]="'general.api_legal_persons_form_promoter'"
                               [searchService]="promoterService"
                               [scrollLoad]="promoterScrollLoadList[promoterIndex]"
                               [objectIdsToAvoid]="legalPerson.promoters"
                               [(selectedObjectId)]="legalPersonPromoterIds[promoterIndex]"
                               (selectedObjectIdChange)="selectPromoter(promoterIndex)"></app-scroll-load>
            </td>
            <td class="align-right min-width white-space-no-wrap" *ngIf="canChange">
              <button mat-button class="input-button icon-button" *ngIf="!editPromoters[promoterId]" (click)="editPromoters[promoterId] = true">
                <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
              </button>
              <button mat-button class="input-button icon-button" *ngIf="editPromoters[promoterId]" (click)="savePromoter(promoterId)" [disabled]="!promoterId || !legalPersonOrig.salespoints?.length">
                <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
              </button>
              <button mat-button class="input-button icon-button left-spacer" (click)="removePromoter(promoterIndex)">
                <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </mat-card>
</ng-template>

<ng-template #shopProvidersTemplate>
  <mat-card appearance="outlined" *ngIf="canChange || hasShopProviders">
    <div class="flex flex-wrap space-between">
      <app-section-header [title]="'general.api_legal_persons_form_shop_providers'" [tooltip]="'general.api_legal_persons_form_shop_providers_tooltip'"></app-section-header>
      <div *ngIf="canChange">
        <app-link [link]="'general.api_legal_persons_form_add_shop_provider'"
                  [icon]="'plus'" (linkClicked)="supportsYbo ? addExternalShopProvider() : addShopProvider()">
        </app-link>
      </div>
    </div>
    <ng-container *ngIf="supportsYbo; then externalShopProvidersTable; else shopProvidersTable"></ng-container>
  </mat-card>
</ng-template>

<ng-template #externalShopProvidersTable>
  <table class="report-table top-margin" *ngIf="legalPersonShopProviders.length">
    <tbody>
    <tr *ngFor="let shopProvider of legalPersonShopProviders; let providerIndex = index">
      <td class="max-width">
        <span *ngIf="!editShopProviders[shopProvider.id] || !canChange || authService.user.isSubCentre">
            <span class="title">{{ shopProvider.tag || '-' }}</span>({{ shopProvider.name }})
        </span>
        <app-scroll-load *ngIf="editShopProviders[shopProvider.id] && canChange && !authService.user.isSubCentre && shopProviderScrollLoadList[providerIndex]"
                         [maxWidth]="true"
                         [label]="'general.api_legal_persons_form_shop_provider_tag'"
                         [placeholder]="'general.api_legal_persons_form_shop_provider'"
                         [searchService]="shopProviderService"
                         [scrollLoad]="shopProviderScrollLoadList[providerIndex]"
                         [objectIdsToAvoid]="attachedShopProviderIds"
                         [(selectedObjectId)]="shopProvider.id"
                         (selectedObjectIdChange)="selectExternalShopProvider(shopProvider.id, providerIndex)"></app-scroll-load>
      </td>
      <td class="align-right min-width white-space-no-wrap" *ngIf="canChange">
        <button mat-button class="input-button icon-button" *ngIf="!editShopProviders[shopProvider.id]" (click)="editShopProviders[shopProvider.id] = true">
          <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
        </button>
        <button mat-button class="input-button icon-button" *ngIf="editShopProviders[shopProvider.id]" (click)="saveExternalShopProvider(shopProvider.id, providerIndex)" [disabled]="!shopProvider.id">
          <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
        </button>
        <button mat-button class="input-button icon-button left-spacer" (click)="removeExternalShopProvider(shopProvider.id, providerIndex)">
          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</ng-template>

<ng-template #shopProvidersTable>
  <table class="report-table top-margin" *ngIf="legalPerson.shopProviders.length">
    <tbody>
    <ng-container *ngFor="let shopProvider of legalPerson.shopProviders; let index = index">
      <tr *ngIf="shopProvider.tag">
        <td class="max-width">
          <span class="title">{{ shopProvider?.tag || '-' }}</span>({{ shopProvider?.name }})
        </td>
        <td class="align-right min-width white-space-no-wrap" *ngIf="canChange">
          <button mat-button class="input-button icon-button" (click)="editShopProvider(index)">
            <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
          </button>
          <button mat-button class="input-button icon-button left-spacer" (click)="removeShopProvider(shopProvider.id, index)">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          </button>
        </td>
      </tr>
    </ng-container>
    </tbody>
  </table>
</ng-template>

<ng-template #salespointsTemplate>
  <mat-card appearance="outlined" *ngIf="(!legalPerson.salespoints.length || legalPerson.salespoints[0].supportsYbo) && (canChange || legalPerson.salespoints.length)">
    <div class="flex flex-wrap space-between">
      <app-section-header [title]="'general.api_legal_persons_form_salespoints'" [tooltip]="'general.api_legal_persons_form_salespoints_tooltip'"></app-section-header>
      <div *ngIf="canChange">
        <a class="link" (click)="addSalespoint()">
          <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
          <span>{{ 'general.api_legal_persons_form_add_salespoint' | translate }}</span>
        </a>
      </div>
    </div>
    <table class="report-table top-spacer" *ngIf="legalPerson.salespoints?.length">
      <tbody>
        <tr *ngFor="let salespoint of legalPerson.salespoints; let salespointIndex = index">
          <td>
            <span *ngIf="!editSalespoints[salespoint.id] || !canChange || authService.user.isSubCentre">
              {{ salespoint.name }}
              <ng-container *ngIf="salespoint.alias">&nbsp;({{ salespoint.alias.name }})</ng-container>
            </span>
            <app-scroll-load *ngIf="editSalespoints[salespoint.id] && canChange && !authService.user.isSubCentre && salespointScrollLoadList[salespointIndex]"
                             [maxWidth]="true"
                             [label]="'general.api_legal_persons_form_salespoint'"
                             [customFilters]="{filters:{targetLegalPersonIdIsNull: true}}"
                             [customQuery]="salespointsService.setPageableQuery"
                             [searchService]="salespointsService"
                             [scrollLoad]="salespointScrollLoadList[salespointIndex]"
                             [objectIdsToAvoid]="getSelectedSalespointIds"
                             [objectIdsCanSelect]="salespointsIds"
                             [(selectedObjectId)]="salespoint.id"
                             (selectedObjectIdChange)="selectSalespoint(salespointIndex)"></app-scroll-load>
          </td>
          <td class="align-right min-width white-space-no-wrap" *ngIf="canChange">
            <button mat-button class="input-button icon-button" *ngIf="!editSalespoints[salespoint.id]" (click)="editSalespoints[salespoint.id] = true">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
            <button mat-button class="input-button icon-button" *ngIf="editSalespoints[salespoint.id]" (click)="saveSalespoint(salespoint.id)" [disabled]="!salespoint.id">
              <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
            </button>
            <button mat-button class="input-button icon-button left-spacer" (click)="removeSalespoint(salespointIndex)">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card>
</ng-template>

<ng-template #contactPersonsTemplate>
  <mat-card appearance="outlined" *ngIf="canChange || legalPerson.contactPersons.length">
    <div class="flex flex-wrap space-between">
      <app-section-header [title]="'general.api_legal_persons_form_contact_persons'"></app-section-header>
      <div *ngIf="canChange">
        <a class="link" (click)="addContactPerson()">
          <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
          <span>{{ 'general.api_legal_persons_form_add_contact_person' | translate }}</span>
        </a>
      </div>
    </div>
    <ng-container *ngIf="legalPerson.contactPersons?.length">
      <ng-container *ngIf="utilService.isMobile">
        <hr class="slim top-spacer mobile">
        <div class="mobile">
          <ng-container *ngFor="let contactPerson of legalPerson.contactPersons; let even = even; let index = index">
            <div class="listing-block">
              <div class="header-block flex flex-grow space-between bottom-spacer">
                <div>
                  <a class="heading-5 no-margin break-all link bold" (click)="$event.stopPropagation(); canChange && editContactPerson(index)">
                    {{ contactPerson.firstName }} {{ contactPerson.lastName }}
                  </a>
                </div>
                <div class="white-space-no-wrap no-grow no-min-width" *ngIf="canChange">
                  <div class="flex flex-end">
                    <button mat-button class="input-button icon-button" (click)="editContactPerson(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                    </button>
                    <button mat-button class="input-button icon-button" (click)="removeContactPerson(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <table class="mobile-max-width bottom-spacer">
                <tbody>
                <tr *ngIf="contactPerson.email">
                  <td>{{ 'general.api_legal_persons_form_contact_person_email' | translate }}</td>
                  <td class="align-right break-all">{{ contactPerson.email }}</td>
                </tr>
                <tr *ngIf="contactPerson.phoneNr">
                  <td>{{ 'general.api_legal_persons_form_contact_person_phone' | translate }}</td>
                  <td class="align-right">{{ contactPerson.phoneNr | phoneNumber }}</td>
                </tr>
                <tr *ngIf="contactPerson.isInvoiceRecipient">
                  <td>{{ 'general.api_legal_persons_form_contact_person_invoice_receiver' | translate }}</td>
                  <td class="align-right">
                    <mat-icon *ngIf="contactPerson.isInvoiceRecipient" class="svg-icon" [svgIcon]="'check'"></mat-icon>
                  </td>
                </tr>
                <tr *ngIf="contactPerson.remarks?.length">
                  <td>{{ 'general.api_legal_persons_form_contact_person_remarks' | translate }}</td>
                  <td class="align-right">
                    <mat-icon class="svg-icon svg-icon-slim text-muted" [svgIcon]="'comments'"
                              [matTooltip]="contactPerson.remarks.length > 40 ? ((contactPerson.remarks | trim) + '...') : contactPerson.remarks" [matTooltipPosition]="'left'"></mat-icon>
                  </td>
                </tr>
                </tbody>
              </table>
              <hr class="no-margin">
            </div>
          </ng-container>
        </div>
      </ng-container>
      <table class="report-table desktop top-spacer" *ngIf="!utilService.isMobile && legalPerson.contactPersons[0].firstName">
        <thead>
        <tr>
          <th>{{ 'general.api_legal_persons_form_contact_person_name' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_contact_person_email' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_contact_person_phone' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_contact_person_invoice_receiver' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_contact_person_remarks' | translate }}</th>
          <th class="min-width" *ngIf="canChange">&nbsp;</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let contactPerson of legalPerson.contactPersons; let index = index">
          <tr *ngIf="contactPerson.firstName">
            <td>
              <a class="no-margin break-all link bold" (click)="$event.stopPropagation(); canChange && editContactPerson(index)">
                {{ contactPerson.firstName }} {{ contactPerson.lastName }}
              </a>
            </td>
            <td class="break-all">{{ contactPerson.email || '-' }}</td>
            <td>{{ contactPerson.phoneNr ? (contactPerson.phoneNr | phoneNumber) : '-' }}</td>
            <td>
              <ng-container *ngIf="!contactPerson.isInvoiceRecipient">-</ng-container>
              <mat-icon *ngIf="contactPerson.isInvoiceRecipient" class="svg-icon" [svgIcon]="'check'"></mat-icon>
            </td>
            <td>
              <ng-container *ngIf="!contactPerson.remarks?.length">-</ng-container>
              <mat-icon class="svg-icon text-muted" [svgIcon]="'comments'" *ngIf="contactPerson.remarks?.length"
                        [matTooltip]="contactPerson.remarks.length > 40 ? ((contactPerson.remarks | trim) + '...') : contactPerson.remarks" [matTooltipPosition]="'left'"></mat-icon>
            </td>
            <td class="align-right min-width" *ngIf="canChange">
              <div class="flex flex-end">
                <button mat-button class="input-button icon-button" (click)="editContactPerson(index)">
                  <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                </button>
                <button mat-button class="input-button icon-button" *ngIf="canChange" (click)="removeContactPerson(index)">
                  <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </ng-container>
  </mat-card>
</ng-template>

<ng-template #modalTemplate let-data>
  <app-dialog-header [title]="data.title" [withConfirm]="true" (closed)="data.closeModal()" [tooltip]="data.titleTooltip"></app-dialog-header>
  <mat-dialog-content>
    <div class="flex flex-column flex-column-mobile bottom-spacer-x2">
      <ng-container *ngTemplateOutlet="data.template; context: {data: data}"></ng-container>
    </div>
  </mat-dialog-content>
  <app-dialog-footer [dialogActions]="modalButtonsTemplate"></app-dialog-footer>
  <ng-template #modalButtonsTemplate>
    <button mat-button (click)="data.closeModal()">
      {{ 'general.api_general_close' | translate }}
    </button>
    <button mat-stroked-button color="primary" *ngIf="data.primaryButton" (click)="data.primaryAction(data)"
            [disabled]="data?.primaryButtonDisabled && data.primaryButtonDisabled()">
      {{ data.primaryButton | translate }}
    </button>
    <button mat-stroked-button color="primary" *ngIf="data.secondaryButton" (click)="data.secondaryAction(data)"
            [disabled]="data?.secondaryButtonDisabled && data.secondaryButtonDisabled()">
      {{ data.secondaryButton | translate }}
    </button>
    <button mat-flat-button color="primary" (click)="data.closeModal(data.model)" *ngIf="data.saveButton"
            [disabled]="!data.isValid()">
      {{ data.saveButton | translate }}
    </button>
  </ng-template>
</ng-template>

<ng-template #contactPersonModalContent let-data="data">
  <app-text-input [label]="'general.api_legal_persons_form_contact_person_first_name'" [(value)]="data.model.firstName"
                  [max]="CONTACT_PERSON_NAME_MAX_LENGTH" [required]="true"></app-text-input>
  <app-text-input [label]="'general.api_legal_persons_form_contact_person_last_name'" [(value)]="data.model.lastName"
                  [max]="CONTACT_PERSON_NAME_MAX_LENGTH" [required]="true"></app-text-input>
  <app-text-input [type]="TextInputType.Email" [label]="'general.api_legal_persons_form_contact_person_email'" [(value)]="data.model.email"
                  [customErrorFunction]="data.validations.isEmailExist()" [customError]="'general.api_legal_persons_form_contact_person_email_already_exist'"></app-text-input>
  <app-phone-input [(phoneNr)]="data.model.phoneNr" [label]="'general.api_legal_persons_form_contact_person_phone'"></app-phone-input>
  <app-text-input [type]="TextInputType.Textarea" [label]="'general.api_legal_persons_form_contact_person_remarks'" [(value)]="data.model.remarks"></app-text-input>
  <mat-checkbox [(ngModel)]="data.model.isPublic">
    {{ 'general.api_legal_persons_form_contact_person_salespoints' | translate }}
  </mat-checkbox>
  <mat-checkbox [(ngModel)]="data.model.isInvoiceRecipient" [disabled]="!data.model.email || data.validations.isEmailExist() || !data.validations.isEmailValid()">
    {{ 'general.api_legal_persons_form_contact_person_invoice_receiver' | translate }}
  </mat-checkbox>
  <app-info-message *ngIf="!data.model.email || data.validations.isEmailExist() || !data.validations.isEmailValid()" [message]="'general.api_legal_persons_form_contact_person_invoice_receiver_info'"></app-info-message>
</ng-template>

<ng-template #projectManagerTemplate>
  <mat-card appearance="outlined" *ngIf="!isRegister && authService.hasProjectManagersAccessPrivileges">
    <app-section-header [title]="'general.api_legal_persons_form_project_manager'"></app-section-header>
    <hr class="slim mobile top-spacer">
    <div class="mobile">
      <div class="listing-block">
        <div class="header-block flex flex-grow space-between bottom-spacer">
          <div>
            <mat-form-field appearance="outline" class="no-hint max-width">
              <mat-label>{{ 'general.api_legal_persons_form_project_manager_name' | translate }}</mat-label>
              <mat-select [(ngModel)]="legalPerson.projectManagerId">
                <mat-option>
                  <app-select-search [values]="projectManagers" [filterBy]="['firstName', 'lastName']" (filteredValues)="projectManagersFiltered.next($event.slice())"></app-select-search>
                </mat-option>
                <mat-option [value]="null">-</mat-option>
                <mat-option *ngFor="let manager of projectManagersFiltered | async" [value]="manager.userId">
                  {{ manager.firstName }} {{ manager.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="white-space-no-wrap no-grow no-min-width">
            <div class="flex flex-end">
              <button mat-button class="input-button icon-button" (click)="saveProjectManager()" [disabled]="legalPersonOrig.projectManagerId === legalPerson.projectManagerId">
                <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
              </button>
            </div>
          </div>
        </div>
        <table class="mobile-max-width bottom-spacer">
          <tbody>
            <tr>
              <td>{{ 'general.api_legal_persons_form_project_manager_email' | translate }}</td>
              <td class="align-right">{{ selectedProjectManager?.email || '-' }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_legal_persons_form_project_manager_phone' | translate }}</td>
              <td class="align-right">{{ selectedProjectManager?.phoneNr ? (selectedProjectManager.phoneNr | phoneNumber) : '-' }}</td>
            </tr>
          </tbody>
        </table>
        <hr class="no-margin">
      </div>
    </div>
    <table class="report-table desktop top-spacer">
      <thead>
        <tr>
          <th>{{ 'general.api_legal_persons_form_project_manager_name' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_project_manager_email' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_project_manager_phone' | translate }}</th>
          <th class="min-width"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <mat-form-field appearance="outline" class="no-hint max-width">
              <mat-label>{{ 'general.api_legal_persons_form_project_manager_name' | translate }}</mat-label>
              <mat-select [(ngModel)]="legalPerson.projectManagerId" (selectionChange)="pendingChanges = true">
                <mat-option>
                  <app-select-search [values]="projectManagers" [filterBy]="['firstName', 'lastName']" (filteredValues)="projectManagersFiltered.next($event.slice())"></app-select-search>
                </mat-option>
                <mat-option [value]="null">-</mat-option>
                <mat-option *ngFor="let manager of projectManagersFiltered | async" [value]="manager.userId">
                  {{ manager.firstName }} {{ manager.lastName }}
                </mat-option>
                <mat-option *ngFor="let manager of projectManagers" [value]="manager.userId" class="hide" disabled>
                  {{ manager.firstName }} {{ manager.lastName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td>{{ selectedProjectManager?.email || '-' }}</td>
          <td>{{ selectedProjectManager?.phoneNr ? (selectedProjectManager.phoneNr | phoneNumber) : '-' }}</td>
          <td class="align-right min-width">
            <button mat-button class="input-button icon-button" (click)="saveProjectManager()" [disabled]="legalPersonOrig.projectManagerId === legalPerson.projectManagerId">
              <mat-icon class="svg-icon" [svgIcon]="'save'"></mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card>
</ng-template>

<ng-template #representativesTemplate>
  <mat-card appearance="outlined" *ngIf="isView && canManageRepresentative || legalPerson?.representatives?.length || legalPerson?.representativeInvites?.length">
    <div class="flex flex-wrap space-between">
      <app-section-header [title]="'general.api_legal_persons_form_representatives'" [tooltip]="'general.api_legal_persons_form_representatives_tooltip'"></app-section-header>
      <div *ngIf="canManageRepresentative">
        <a class="link" (click)="addRepresentative()">
          <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
          <span>{{ 'general.api_legal_persons_form_add_representative' | translate }}</span>
        </a>
      </div>
    </div>
    <mat-tab-group class="max-width top-spacer" *ngIf="legalPerson?.representatives?.length || legalPerson?.representativeInvites?.length"
                  [(selectedIndex)]="representativeTabIndex" (selectedIndexChange)="switchRepresentativeTab()">
      <mat-tab *ngIf="legalPerson?.representatives?.length">
        <ng-template mat-tab-label>
          {{ 'general.api_legal_persons_form_representatives_tab_' + representativeTabMap.VERIFIED | translate }} ({{ representativesCount }})
        </ng-template>
        <ng-container *ngIf="utilService.isMobile">
          <hr class="slim top-spacer mobile">
          <div class="mobile">
            <ng-container *ngFor="let representative of legalPerson.representatives; let even = even; let index = index">
              <div class="listing-block">
                <div class="header-block flex flex-grow space-between bottom-spacer">
                  <div>
                    <a class="heading-5 no-margin break-word link bold" (click)="$event.stopPropagation(); canManageRepresentative && editRepresentative(index)">
                      {{ representative.firstName }} {{ representative.lastName }}
                    </a>
                  </div>
                  <div class="white-space-no-wrap no-grow no-min-width" *ngIf="canManageRepresentative">
                    <div class="flex flex-end">
                      <button mat-button class="input-button icon-button" (click)="editRepresentative(index)">
                        <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                      </button>
                      <button mat-button class="input-button icon-button" (click)="removeRepresentative(index)">
                        <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <table class="mobile-max-width bottom-spacer">
                  <tbody>
                  <tr *ngIf="representative.email">
                    <td>{{ 'general.api_legal_persons_form_representative_email' | translate }}</td>
                    <td class="align-right">{{ representative.email }}</td>
                  </tr>
                  <ng-container *ngFor="let sp of representative.salespointRoles; let spIndex = index">
                    <tr class="with-separator" *ngIf="isAnyRepresentativeHasMultipleSalespoints && (expanded['representative_' + representative.userId] || spIndex === 0)">
                      <td>{{ 'general.api_legal_persons_form_representative_salespoint' | translate }}</td>
                      <td class="align-right">{{ sp.name }}</td>
                    </tr>
                    <tr *ngIf="expanded['representative_' + representative.userId] || spIndex === 0">
                      <td>{{ 'general.api_legal_persons_form_representative_roles' | translate }}</td>
                      <td class="align-right">{{ getRepresentativeRoles(sp.roles) }}</td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="representative.salespointRoles?.length > 1">
                    <td colspan="2" class="align-center">
                      <a class="link body-3 bold" (click)="$event.stopPropagation(); toggleRow('representative_' + representative.userId)">
                        <mat-icon class="svg-icon" [svgIcon]="expanded['representative_' + representative.userId] ? 'arrow_up' : 'arrow_down'"></mat-icon>
                        <span>{{ (expanded['representative_' + representative.userId] ? 'general.api_show_less' : 'general.api_show_more') | translate }}</span>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <hr class="no-margin">
              </div>
            </ng-container>
          </div>
        </ng-container>
        <table class="report-table desktop manual-alternating-color top-spacer" *ngIf="!utilService.isMobile">
          <thead>
            <tr>
              <th>{{ 'general.api_legal_persons_form_representative_name' | translate }}</th>
              <th>{{ 'general.api_legal_persons_form_representative_email' | translate }}</th>
              <th *ngIf="isAnyRepresentativeHasMultipleSalespoints">{{ 'general.api_legal_persons_form_representative_salespoint' | translate }}</th>
              <th>{{ 'general.api_legal_persons_form_representative_roles' | translate }}</th>
              <th class="min-width" *ngIf="canManageRepresentative">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let representative of legalPerson.representatives; let even = even; let index = index">
              <tr *ngIf="representative.email" [ngClass]="{'alternate' : even}">
                <td [rowSpan]="representative.salespointRoles.length">
                  <a class="no-margin link bold" (click)="$event.stopPropagation(); canManageRepresentative && editRepresentative(index)">
                    {{ representative.firstName }} {{ representative.lastName }}
                  </a>
                </td>
                <td [rowSpan]="representative.salespointRoles.length">{{ representative.email }}</td>
                <td *ngIf="isAnyRepresentativeHasMultipleSalespoints">
                  {{ representative.salespointRoles[0].name }}
                </td>
                <td>
                  {{ getRepresentativeRoles(representative.salespointRoles[0].roles) }}
                </td>
                <td [rowSpan]="representative.salespointRoles.length" class="align-right min-width" *ngIf="canManageRepresentative">
                  <div class="flex flex-end">
                    <button mat-button class="input-button icon-button" (click)="editRepresentative(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                    </button>
                    <button mat-button class="input-button icon-button" (click)="removeRepresentative(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                    </button>
                  </div>
                </td>
              </tr>
              <ng-container *ngFor="let sp of representative.salespointRoles; let first = first">
                <tr *ngIf="!first" [ngClass]="{'alternate' : even}">
                  <td>
                    {{ sp.name }}
                  </td>
                  <td>
                    {{ getRepresentativeRoles(sp.roles) }}
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </mat-tab>
      <mat-tab *ngIf="legalPerson?.representativeInvites?.length">
        <ng-template mat-tab-label>
          {{ 'general.api_legal_persons_form_representatives_tab_' + representativeTabMap.INVITES | translate }} ({{ legalPerson.representativeInvites?.length }})
        </ng-template>
        <ng-container *ngIf="utilService.isMobile">
          <hr class="slim top-spacer mobile">
          <div class="mobile">
            <ng-container *ngFor="let invite of legalPerson.representativeInvites; let even = even; let index = index">
              <div class="listing-block">
                <div class="header-block flex flex-grow space-between bottom-spacer">
                  <div>
                    <a class="heading-5 break-word link bold bottom-spacer" (click)="$event.stopPropagation(); canManageRepresentative && editInvite(index)">
                      {{ invite.email }}
                    </a>
                    <span class="badge" [ngClass]="{'warning': invite.inviteStatus === inviteStatus.Expired}">{{ 'general.api_legal_persons_form_representative_status_' +  invite.inviteStatus.toLowerCase() | translate }}</span>
                  </div>
                  <div class="white-space-no-wrap no-grow no-min-width" *ngIf="canManageRepresentative">
                    <div class="flex flex-end">
                      <button mat-button class="icon-button input-button" [matMenuTriggerFor]="inviteActionMenu">
                        <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
                      </button>
                      <mat-menu #inviteActionMenu="matMenu">
                        <button mat-menu-item (click)="resendInvite(index)">
                          <mat-icon class="svg-icon" [svgIcon]="'e_mail_resend'"></mat-icon>
                          <span>{{ 'general.api_legal_persons_form_representative_invite_menu_resend' | translate }}</span>
                        </button>
                        <button mat-menu-item (click)="editInvite(index)">
                          <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                          <span>{{ 'general.api_legal_persons_form_representative_invite_menu_edit' | translate }}</span>
                        </button>
                        <button mat-menu-item (click)="removeInvite(index)">
                          <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                          <span>{{ 'general.api_legal_persons_form_representative_invite_menu_remove' | translate }}</span>
                        </button>
                      </mat-menu>
                    </div>
                  </div>
                </div>
                <table class="mobile-max-width bottom-spacer">
                  <tbody>
                  <ng-container *ngFor="let sp of invite.salespointRoles; let spIndex = index">
                    <tr class="with-separator" *ngIf="isAnyRepresentativeHasMultipleSalespoints && (expanded['invite_' + invite.id] || spIndex === 0)">
                      <td>{{ 'general.api_legal_persons_form_representative_salespoint' | translate }}</td>
                      <td class="align-right">{{ sp.name }}</td>
                    </tr>
                    <tr *ngIf="expanded['invite_' + invite.id] || spIndex === 0">
                      <td>{{ 'general.api_legal_persons_form_representative_roles' | translate }}</td>
                      <td class="align-right">{{ getRepresentativeRoles(sp.roles) }}</td>
                    </tr>
                  </ng-container>
                  <tr *ngIf="invite.salespointRoles?.length > 1">
                    <td colspan="2" class="align-center">
                      <a class="link body-3 bold" (click)="$event.stopPropagation(); toggleRow('invite_' + invite.id)">
                        <mat-icon class="svg-icon" [svgIcon]="expanded['invite_' + invite.id] ? 'arrow_up' : 'arrow_down'"></mat-icon>
                        <span>{{ (expanded['invite_' + invite.id] ? 'general.api_show_less' : 'general.api_show_more') | translate }}</span>
                      </a>
                    </td>
                  </tr>
                  </tbody>
                </table>
                <hr class="no-margin">
              </div>
            </ng-container>
          </div>
        </ng-container>
        <table class="report-table desktop manual-alternating-color top-spacer" *ngIf="!utilService.isMobile">
          <thead>
            <tr>
              <th>{{ 'general.api_legal_persons_form_representative_invite_email' | translate }}</th>
              <th>{{ 'general.api_legal_persons_form_representative_invite_status' | translate }}</th>
              <th *ngIf="isAnyRepresentativeHasMultipleSalespoints">{{ 'general.api_legal_persons_form_representative_invite_salespoint' | translate }}</th>
              <th>{{ 'general.api_legal_persons_form_representative_invite_roles' | translate }}</th>
              <th class="min-width" *ngIf="canManageRepresentative">&nbsp;</th>
            </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let invite of legalPerson.representativeInvites; let even = even; let index = index">
            <tr [ngClass]="{'alternate' : even}">
              <td [rowSpan]="invite.salespointRoles.length">
                <a class="no-margin link bold" (click)="$event.stopPropagation(); canManageRepresentative && editInvite(index)">
                  {{ invite.email }}
                </a>
              </td>
              <td [rowSpan]="invite.salespointRoles.length">
                <span class="badge" [ngClass]="{'warning': invite.inviteStatus === inviteStatus.Expired}">{{ 'general.api_legal_persons_form_representative_status_' +  invite.inviteStatus.toLowerCase() | translate }}</span>
              </td>
              <td *ngIf="isAnyRepresentativeHasMultipleSalespoints">
                {{ invite.salespointRoles[0].name }}
              </td>
              <td>
                {{ getRepresentativeRoles(invite.salespointRoles[0].roles) }}
              </td>
              <td [rowSpan]="invite.salespointRoles.length" class="align-right min-width" *ngIf="canManageRepresentative">
                <div class="flex flex-end">
                  <button mat-button class="input-button icon-button" (click)="resendInvite(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'e_mail_resend'"></mat-icon>
                  </button>
                  <button mat-button class="input-button icon-button" (click)="editInvite(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                  </button>
                  <button mat-button class="input-button icon-button" (click)="removeInvite(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                  </button>
                </div>
              </td>
            </tr>
            <ng-container *ngFor="let sp of invite.salespointRoles; let first = first">
              <tr *ngIf="!first" [ngClass]="{'alternate' : even}">
                <td>
                  {{ sp.name }}
                </td>
                <td>
                  {{ getRepresentativeRoles(sp.roles) }}
                </td>
              </tr>
            </ng-container>
          </ng-container>
          </tbody>
        </table>
      </mat-tab>
    </mat-tab-group>
  </mat-card>
</ng-template>

<ng-template #representativesModalContent let-data="data">
  <div *ngIf="!data.model.userId && !data.model.inviteStatus" [ngClass]="{'card-grid grid-column-mobile no-gap grid-2': legalHasMultipleSalespoints || legalHasAliasSalespoints}">
    <div class="flex flex-grow flex-column-mobile">
      <app-text-input [type]="TextInputType.Email" [label]="'general.api_legal_persons_form_representative_email'" [(value)]="data.model.email"
                      [customErrorFunction]="data.validations.isEmailExist()" [customError]="'general.api_legal_persons_form_representative_email_already_exist'"></app-text-input>
    </div>
    <div *ngIf="legalHasMultipleSalespoints || legalHasAliasSalespoints"></div>
  </div>
  <div class="flex flex-autosize align-left flex-column-mobile" *ngIf="data.model.userId || data.model.inviteStatus">
    <div *ngIf="data.model.firstName">
      <div class="text-muted">{{ 'general.api_legal_persons_form_representative_name' | translate }}:</div>
      <div class="bold top-spacer bottom-spacer body-2">{{ data.model.firstName }} {{ data.model.lastName }}</div>
    </div>
    <div>
      <div class="text-muted">{{ 'general.api_legal_persons_form_representative_email' | translate }}:</div>
      <div class="bold top-spacer bottom-spacer body-2">{{ data.model.email }}</div>
    </div>
  </div>
  <ng-container *ngFor="let salespoint of data.model.salespointRoles; let index = index">
    <hr class="extra-slim" *ngIf="data.model.salespointRoles.length > 1">
    <div [ngClass]="{'card-grid grid-column-mobile grid-2': legalHasMultipleSalespoints || legalHasAliasSalespoints}" *ngIf="!isAliasSalespoint(salespoint.id)">
      <div *ngIf="legalHasMultipleSalespoints || legalHasAliasSalespoints">
        <mat-form-field appearance="outline" class="no-hint max-width">
          <mat-label>{{ 'general.api_legal_persons_form_representative_salespoint' | translate }}</mat-label>
          <mat-select [(ngModel)]="salespoint.id" [disabled]="data.model.inviteStatus" [required]="true">
            <mat-option [value]="null">-</mat-option>
            <mat-option *ngFor="let sp of salespointsFiltered(data.model.salespointRoles, salespoint.id)" [value]="sp.id">
              {{ sp.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div *ngIf="aliasSalespoint(salespoint.id)" class="top-spacer">
          {{'general.api_users_form_related_alias_salespoint' | translate}}: <b>{{ aliasSalespoint(salespoint.id).name }}</b>
        </div>
      </div>
      <div>
        <div class="flex flex-grow">
          <div>
            <mat-form-field appearance="outline" class="no-hint max-width">
              <mat-label>{{ 'general.api_legal_persons_form_representative_roles' | translate }}</mat-label>
              <mat-select [(ngModel)]="salespoint.roles" [compareWith]="salespointRolesCompare" [multiple]="true" [disabled]="!salespoint.id" [required]="true">
                <mat-option *ngFor="let role of salespointRoles(salespoint.id)" [value]="role">
                  {{ role.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div *ngIf="aliasSalespoint(salespoint.id)">
              <mat-form-field appearance="outline" class="no-hint max-width top-spacer">
                <mat-label>{{ 'general.api_legal_persons_form_representative_roles' | translate }}</mat-label>
                <mat-select [(ngModel)]="salespoint.aliasRoles" [compareWith]="salespointRolesCompare" [multiple]="true" [disabled]="!salespoint.id" [required]="true">
                  <mat-option *ngFor="let role of salespointRoles(aliasSalespoint(salespoint.id).id)" [value]="role">
                    {{ role.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <button mat-button class="input-button icon-button flex-button" (click)="data.removeAction(index)" *ngIf="!data.model.inviteStatus && data.removeAction && data.model.salespointRoles.length > 1">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #billingTemplate>
  <mat-card appearance="outlined">
    <div class="flex flex-wrap space-between">
      <app-section-header [title]="'general.api_legal_persons_form_billing'" [tooltip]="'general.api_legal_persons_form_billing_tooltip'"></app-section-header>
      <ng-container *ngIf="authService.checkPrivileges([Privileges.LEGAL_PERSON_BANK_ACCOUNT_ADD_VIA_PAYMENT_LINK, Privileges.LEGAL_PERSON_ADMIN])">
        <div class="flex flex-self-start">
          <a class="link" (click)="billingAddBankAccount()">
            <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
            <span>{{ 'general.api_legal_persons_form_billing_add_payment' | translate }}</span>
          </a>
        </div>
      </ng-container>
    </div>
    <mat-tab-group #bankAccountTabs [(selectedIndex)]="bankAccountStatusTab" mat-align-tabs="left" animationDuration="0ms" class="tabs no-body max-width top-spacer">
      <mat-tab *ngFor="let status of BankAccountStatuses" [label]="'general.api_legal_persons_form_billing_status_' + status.toLowerCase() | translate"></mat-tab>
    </mat-tab-group>
    <div class="mobile">
      <div class="listing-block" *ngFor="let item of billingBankAccountsByTab">
        <div class="header-block flex flex-grow space-between bottom-spacer">
          <div>
            <div class="heading-5 no-margin break-word bold">
              {{ item.iban }}
            </div>
            <small class="bold">
              <ng-container *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Active">
                {{ item.activated | moment }}
              </ng-container>
              <ng-container *ngIf="billingStatus">
                {{ item.pended | moment }}
              </ng-container>
              <ng-container *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Archived">
                {{ (item.activated || item.pended) | moment }} - {{ item.archived | moment }}
              </ng-container>
            </small>
          </div>
          <div class="white-space-no-wrap no-grow no-min-width">
            <div class="flex flex-end">
              <button mat-button class="input-button icon-button small" (click)="confirmAndAddManually(item.iban)" *ngIf="billingStatus && canAddBankAccountManually">
                <mat-icon class="svg-icon" [svgIcon]="'check'"></mat-icon>
              </button>
            </div>
          </div>
        </div>
        <table class="mobile-max-width bottom-spacer" *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Invalid">
          <tbody>
            <tr>
              <td>{{ 'general.api_legal_persons_form_billing_account_holder' | translate }}</td>
              <td class="align-right">
                {{ item.accountHolder }}
              </td>
            </tr>
          </tbody>
        </table>
        <hr class="no-margin">
      </div>
    </div>
    <table class="report-table desktop no-border">
      <thead>
        <tr>
          <th>{{ 'general.api_legal_persons_form_billing_account' | translate }}</th>
          <th>{{ 'general.api_legal_persons_form_billing_date' | translate }}</th>
          <th *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Invalid">{{ 'general.api_legal_persons_form_billing_account_holder' | translate }}</th>
          <th class="min-width"></th>
        </tr>
      </thead>
      <tbody *ngFor="let item of billingBankAccountsByTab">
        <tr>
          <td class="bold">
            {{ item.iban }}
          </td>
          <td>
            <ng-container *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Active">
              {{ item.activated | moment }}
            </ng-container>
            <ng-container *ngIf="billingStatus">
              {{ item.pended | moment }}
            </ng-container>
            <ng-container *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Archived">
              {{ (item.activated || item.pended) | moment }} - {{ item.archived | moment }}
            </ng-container>
          </td>
          <td *ngIf="BankAccountStatuses[bankAccountStatusTab] === BankAccountStatus.Invalid">
            {{ item.accountHolder }}
          </td>
          <td class="align-right min-width">
            <button mat-button class="input-button small" (click)="confirmAndAddManually(item.iban)" *ngIf="billingStatus && canAddBankAccountManually">
              <mat-icon class="svg-icon" [svgIcon]="'check'"></mat-icon>
              {{ 'general.api_legal_persons_form_billing_confirm' | translate }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card>
</ng-template>

<ng-template #billingPaymentLinkModalContent let-data="data">
  <h5 class="bold">{{ 'general.api_legal_persons_form_billing_add_payment_verification_title' | translate }}</h5>
  <p [innerHTML]="'general.api_legal_persons_form_billing_add_payment_verification_content' | translate"></p>
  <h5 class="bold">{{ 'general.api_legal_persons_form_billing_add_payment_link_title' | translate }}</h5>
  <ng-container *ngIf="!isBankAccountPending">
    <div class="flex bottom-spacer">
      <ng-container *ngIf="!generatePaymentLink; else linkTemplate">
        <button mat-flat-button color="primary" (click)="data.additionalAction()">
          {{ 'general.api_legal_persons_form_billing_add_payment_link_generate' | translate }}
        </button>
      </ng-container>
      <ng-template #linkTemplate>
        <app-loader [loading]="data.isLoading()" [size]="16"></app-loader>
        <ng-container *ngIf="!data.isLoading()">
          <a class="link" [attr.href]="data.model().link" target="_blank">
            <mat-icon class="svg-icon" [svgIcon]="'link'"></mat-icon>
            <span>{{ 'general.api_legal_persons_form_billing_add_payment_link_text' | translate:{ link: data.model().link } }}</span>
          </a>
          <button mat-button class="input-button icon-button small" (click)="data.secondaryAction()">
            <mat-icon class="svg-icon" [svgIcon]="'copy'"></mat-icon>
          </button>
        </ng-container>
      </ng-template>
    </div>
  </ng-container>
  <ng-container *ngIf="isBankAccountPending">
    <p [innerHTML]="'general.api_legal_persons_form_billing_add_payment_pending_account_already_exists' | translate"></p>
  </ng-container>
  <h5 class="bold">{{ 'general.api_legal_persons_form_billing_add_payment_payouts_title' | translate }}</h5>
  <p [innerHTML]="'general.api_legal_persons_form_billing_add_payment_payouts_content' | translate"></p>
</ng-template>

<ng-template #billingAddManuallyModalContent let-data="data">
  <p [innerHTML]="'general.api_legal_persons_form_billing_add_manually_content' | translate"></p>
  <app-text-input [label]="'general.api_legal_persons_form_billing_iban'" [(value)]="data.model.iban"
                  [hasCustomError]="data.validations.isInvalid()" [customError]="'general.api_legal_persons_form_billing_iban_format_invalid'"
                  [required]="true"></app-text-input>
</ng-template>

<ng-template #adminInfoTemplate>
  <mat-card appearance="outlined">
    <app-section-header [title]="'general.api_legal_persons_form_admin_billing'"></app-section-header>
    <div class="flex flex-column-mobile">
      <app-text-input [label]="'general.api_legal_persons_form_bank_account'"
                      [(value)]="legalPerson.bankAccount" (valueChange)="pendingChanges = true" [disabled]="isView && !canChange"></app-text-input>
      <mat-form-field appearance="outline" class="no-hint" *ngIf="authService.checkPrivileges(Privileges.LEGAL_PERSON_ADMIN)">
        <mat-label>{{ 'general.api_legal_persons_form_invoicing_period' | translate }}</mat-label>
        <mat-select [(ngModel)]="legalPerson.invoicingPeriod" [ngModelOptions]="{standalone: true}" (selectionChange)="invoicingChanged = true" [disabled]="isView && !canChange">
          <mat-option [value]="null">
            {{ 'general.api_legal_persons_form_invoicing_period_none' | translate }}
          </mat-option>
          <mat-option *ngFor="let invoicingPeriod of invoicingPeriods" [value]="invoicingPeriod">
            {{ 'general.api_legal_persons_form_invoicing_period_' + invoicingPeriod | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-card>
  <ng-container *ngTemplateOutlet="salespointsTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="promotersTemplate"></ng-container>
  <ng-container *ngTemplateOutlet="shopProvidersTemplate"></ng-container>
</ng-template>

<ng-template #auditLogTemplate>
  <mat-card appearance="outlined">
    <audit-log-table [pageData]="auditLogPage" [(page)]="auditPageNumber" (pageChange)="getAuditLogs()" [showEntityType]="true"></audit-log-table>
  </mat-card>
</ng-template>

<ng-template #analyticsTrackersTemplateModalContent let-data="data">
  <mat-form-field appearance="outline" class="no-hint max-width" *ngIf="data.mode === 'ADD'">
    <mat-label>{{ 'general.api_legal_persons_form_analytics_trackers_type' | translate }}</mat-label>
    <mat-select [(ngModel)]="data.model.type" (selectionChange)="pendingChanges = true" [required]="true">
      <mat-option>
        <app-select-search
          [filterBy]="['translationKey']"
          [translateValues]="true"
          [values]="getNotUsedAnalyticsTrackerTypes"
          (filteredValues)="analyticsTrackersTypesFiltered.next($event.slice())"
        ></app-select-search>
      </mat-option>
      <mat-option *ngFor="let tracker of analyticsTrackersTypesFiltered | async" [value]="tracker.type">
        {{ tracker.translationKey | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <div class="dialog-info" *ngIf="data.mode === 'UPDATE'">
    <div class="label-value">
      <span class="label">{{'general.api_legal_persons_form_analytics_trackers_type' | translate}}:</span>
      {{ 'general.legal_persons_analytics_tracker_type_' + data.model.type | translate }}
    </div>
  </div>
  <app-text-input
    [label]="'general.api_legal_persons_form_analytics_tracker_value'"
    [(value)]="data.model.value"
    [max]="ANALYTICS_TRACKER_MAX_LENGTH"
    [required]="true"
  ></app-text-input>
</ng-template>

<ng-template #analyticsTrackersTemplate>
  <mat-card>
    <div class="flex flex-wrap space-between break-word">
      <app-section-header [title]="'general.api_legal_persons_analytics_trackers'" [tooltip]="'general.api_legal_persons_analytics_trackers_tooltip'"></app-section-header>
      <a class="link" (click)="addAnalyticsTracker()">
        <mat-icon class="svg-icon" [svgIcon]="'plus'"></mat-icon>
        <span>{{ 'general.api_legal_persons_add_analytics_tracker' | translate }}</span>
      </a>
    </div>

    <ng-container *ngIf="legalPerson.analyticsTrackers?.length">
      <ng-container *ngIf="utilService.isMobile">
        <hr class="slim top-spacer mobile">
        <div class="mobile">
          <ng-container *ngFor="let analyticsTracker of legalPerson.analyticsTrackers; let index = index">
            <div class="listing-block">
              <div class="header-block flex flex-grow space-between bottom-spacer">
                <div>
                  <span class="heading-5 no-margin break-word bold">
                    {{ ('general.legal_persons_analytics_tracker_type_' + analyticsTracker.type) | translate }}
                  </span>
                </div>
                <div class="white-space-no-wrap no-grow no-min-width">
                  <div class="flex flex-end">
                    <button mat-button class="input-button icon-button" (click)="updateAnalyticsTracker(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                    </button>
                    <button mat-button class="input-button icon-button" (click)="removeAnalyticsTracker(index)">
                      <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <table class="mobile-max-width bottom-spacer">
                <tbody>
                  <tr>
                    <td class="break-word">{{ 'general.api_legal_persons_table_analytics_tracker_value' | translate }}</td>
                    <td class="align-right break-word">{{ analyticsTracker.value }}</td>
                  </tr>
                </tbody>
              </table>
              <hr class="no-margin">
            </div>
          </ng-container>
        </div>
      </ng-container>

      <table class="report-table desktop top-spacer">
        <thead>
          <tr>
            <th>{{ 'general.api_legal_persons_table_analytics_tracker_type' | translate }}</th>
            <th>{{ 'general.api_legal_persons_table_analytics_tracker_value' | translate }}</th>
            <th class="min-width"></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let analyticsTracker of legalPerson.analyticsTrackers; let index = index">
            <tr *ngIf="analyticsTracker.type && analyticsTracker.value">
              <td>{{ 'general.legal_persons_analytics_tracker_type_' + analyticsTracker.type | translate }}</td>
              <td>{{ analyticsTracker.value }}</td>
              <td class="align-right min-width">
                <div class="flex flex-end">
                  <button mat-button class="input-button icon-button" (click)="updateAnalyticsTracker(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
                  </button>
                  <button mat-button class="input-button icon-button" (click)="removeAnalyticsTracker(index)">
                    <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>
  </mat-card>
</ng-template>

<ng-template #ownerCentreSettingsTemplate>
  <mat-card appearance="outlined">
    <app-s3-uploader [id]="legalPerson.id" [(model)]="legalPerson.purchaseEmailImage"
                     [ratio]="S3UploaderRatios.Email" [type]="S3UploaderTypes.Legal"
                     [disabled]="isView && !canChange" [canDelete]="false"
                     [title]="'general.api_legal_person_email_image'" [titleHint]="'general.api_legal_person_email_image_hint'"
                     [button]="'general.api_legal_person_email_image_add'" [hint]="'general.api_legal_person_email_image_add_hint'"
    ></app-s3-uploader>
  </mat-card>
</ng-template>

<ng-template #shopProviderModalContent let-data="data">
  <app-text-input [label]="'general.api_legal_persons_form_add_shop_provider_portal_id'" [(value)]="data.model.tag" [required]="true"></app-text-input>
  <app-text-input [label]="'general.api_legal_persons_form_add_shop_provider_name'" [(value)]="data.model.name" [required]="true"></app-text-input>
</ng-template>
